import * as api from "services/Api";
import { generateAction, RequestTypes } from "./Util";

export const GET_ACCOUNTS = new RequestTypes("GET_ACCOUNTS");

export const getAccounts = () => generateAction(GET_ACCOUNTS, () => api.getAccounts());
